import useInsuranceProviders from './use-insurance-providers';

const useInsuranceProvider = (insuranceProviderId) => {
  const insuranceProviders = useInsuranceProviders();
  return insuranceProviders.find((insuranceProvider) => {
    return insuranceProvider.insuranceProviderId === insuranceProviderId;
  });
};

export default useInsuranceProvider;
